import { getHeaders, makeRequest, fetchwithoutToken } from "$utils/utils";
import config from "$services/config";

const { shipping_api_url: shipping_url } = config;

export const getPublicShippingRecord = async (token: string, id: string) => {
  const res = await makeRequest(
    `${shipping_url}/public/shippingRecords/${id}`,
    "GET",
    undefined,
    getHeaders(token)
  );
  return res.data;
};

export const exportPdf = async (idOp: string, op: any) => {
  try {
    const { data } = await fetchwithoutToken(`/api/public/ops/${idOp}/pdf`, {
      method: "POST",
      data: { op },
      responseType: "arraybuffer",
    });
    if (!data) {
      throw new Error("Error when generating pdf");
    }
    return data as any;
  } catch (err) {
    throw new Error(
      "Une erreur s'est produite lors de l'ajout de l'expression de besoin"
    );
  }
};

export default getPublicShippingRecord;
